var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 0H18C18.5304 0 19.0391 0.210714 19.4142 0.585786C19.7893 0.960859 20 1.46957 20 2V14C20 14.5304 19.7893 15.0391 19.4142 15.4142C19.0391 15.7893 18.5304 16 18 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2C0 0.9 0.9 0 2 0ZM18 3.38V2H2V3.38L10 7.38L18 3.38ZM18 5.62L10.45 9.39C10.3104 9.46033 10.1563 9.49697 10 9.49697C9.8437 9.49697 9.68958 9.46033 9.55 9.39L2 5.62V14H18V5.62Z","fill":"#121212","fillOpacity":"0.64"}));
}

Mail.defaultProps = {"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none"};

module.exports = Mail;

Mail.default = Mail;



//////////////////
// WEBPACK FOOTER
// ./~/svg-react-loader/lib/loader.js?name=Mail!./src/images/icon-mail.svg
// module id = 434
// module chunks = 114276838955818